import { UAParser } from 'ua-parser-js';

const getClientMetadata = () => {
    const referrer = document.referrer;
    const { device } = UAParser(navigator.userAgent);

    if (device) {
        const isDesktop = device.type === undefined || ['console', 'smarttv'].includes(device.type);
        const isMobile = device.type !== undefined && ['mobile', 'tablet'].includes(device.type);
        return {
            referrer,
            deviceType: isDesktop ? 1 : isMobile ? 2 : null,
        };
    }
    return {
        referrer,
        deviceType: null,
    };
};

export default function (): { [key: string]: string } {
    const { deviceType, referrer } = getClientMetadata();

    const headers: { [key: string]: string } = {
        'X-Real-Referrer': referrer,
        // 'X-Real-IP':ip
    };

    if (deviceType) {
        headers['X-Device-Type'] = deviceType.toString();
    }

    return headers;
}
